import CryptoJS from 'crypto-js'

export default {
    //加密
    encrypt(iv, keyStr){ 
      let key  = CryptoJS.enc.Utf8.parse(keyStr || 'syzh2021');
      let srcs = CryptoJS.enc.Utf8.parse(iv);
      let encrypted = CryptoJS.AES.encrypt(srcs, key, {mode:CryptoJS.mode.ECB,padding: CryptoJS.pad.Pkcs7});
      return encrypted.toString();
    },
    //解密
    decrypt(iv, keyStr){ 
      let key  = CryptoJS.enc.Utf8.parse(keyStr || 'syzh2021');
      let decrypt = CryptoJS.AES.decrypt(iv, key, {mode:CryptoJS.mode.ECB,padding: CryptoJS.pad.Pkcs7});
      return CryptoJS.enc.Utf8.stringify(decrypt).toString();
    }
  
  }


// WEBPACK FOOTER //
// ./src/assets/js/crypto.js